import { render, staticRenderFns } from "./mdfPassword.vue?vue&type=template&id=1b4aa122&scoped=true&"
import script from "./mdfPassword.vue?vue&type=script&lang=js&"
export * from "./mdfPassword.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=1b4aa122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4aa122",
  null
  
)

export default component.exports